import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import Moment from "moment";
import { setExtracoesSelecionadas } from "src/reducers/loteria/loteriaActions";

import ModalidadeInput from "./modalidade/modalidadeInput";
import {
  changeNumerpApostaClear,
  changeNumerpAposta,
  addNumeroAposta,
  changeNumeroApostaClearAll,
} from "src/reducers/modalidade/modalidadeInputAction";
import { repeatedAposta } from "src/reducers/repeticao/repeticaoActions";
import {
  extractDefaultPremioExtracao,
  getExtracaoDescricao,
} from "./utils/extracaoUtils";
import { geraSurpresinha } from "./utils/apostaUtils";
import { arrayRemove } from "./utils/utils";

import { selectModalidade } from "src/reducers/loteria/loteriaActions";
import {
  addAposta,
  removeAposta,
  enviarAposta,
} from "src/reducers/carrinho/carrinhoActions";
import { selectConcursoScreen } from "src/reducers/concurso/concursoActions";
import { startSession } from "src/reducers/usuario/usuarioActions";

import { convertIntegerToMoney, getOrientation } from "src/modules/helpers";
import ExtracaoSelector from "./extracao/extracaoSelector";

import "./modalidade/modalidade.css";
import { Ticket } from "src/rifa/components";
import ValorInput from "src/newDesign/components/valor-input";
import Carrinho from "src/newDesign/components/carrinho";
import { createRef } from "react";
import {
  hasLogin,
  hasPixParam,
  hasPreTicketParam,
  hasWalletParam,
  savePreTicket,
} from "../utils/getPreTickets";
import PixTicket from "../rifa/components/pixticket";
import { PayButton } from "../common/cart/payButton";
import { saveCart, getSavedCart, removeSavedCart } from "../modules/localStorage";
import { forceInt } from "../utils/forceInt";

import {
  AnalyticsSetGameStep,
  AnalyticsSetFinishPurchase
} from "src/reducers/analytics/analyticsActions";

class LoteriaBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Aposta_ID: 0,
      possivelRetorno: "0,00",
      valorTotal: 0,
      totalGeral: 0,
      messageETicket: "",
      currentETicket: null,
      orientation: getOrientation(),
      showETicket: false,
      ticketError: false,
      firstRendering: true,
      listPremiosSelecionados: [],
      listExtracoesSelecionadas: [],
      activeModalidade: null,
      radioGroupName: "radioExtracoes",
      tipoJogoCorrente: 0,
      apostaDate: "",
      isPreTicket: false,
      hasPreTicketParam: false,
      hasPixParam: false,
      hasWalletParam: false,
      hasLogin: false,
    };

    this.handleChkExtracaoChange = this.handleChkExtracaoChange.bind(this);
    this.handlePremioClick = this.handlePremioClick.bind(this);
    this.adicionaAposta = this.adicionaAposta.bind(this);
    this.reusaAposta = this.reusaAposta.bind(this);
    this.apostaButtonClick = this.apostaButtonClick.bind(this);
    this.atualizaPossivelRetorno = this.atualizaPossivelRetorno.bind(this);
    this.eTicketOK = this.eTicketOK.bind(this);
    this.limparSelecao = this.limparSelecao.bind(this);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.surpresaButtonClick = this.surpresaButtonClick.bind(this);
    this.toggleETicketModal = this.toggleETicketModal.bind(this);
    this.goHome = this.goHome.bind(this);
    this.doOnOrientationChange = this.doOnOrientationChange.bind(this);
    this.incrementValue = this.incrementValue.bind(this);
    this.dateSelect = this.dateSelect.bind(this);
    this.verificaFluxoRepeticao = this.verificaFluxoRepeticao.bind(this);
    this.createTransaction = this.createTransaction.bind(this);

    //Armazena a referência do checkBoxList
    this.chkExtracoes = null;
    this.setChkExtracoesRef = (element) => {
      this.chkExtracoes = element;
    };
    this.carrinhoRef = createRef(null);
    this.apostaRef = this.props.apostaRef || createRef(null);
    this.topRef = this.props.topRef || createRef(null);
  }

  componentWillMount() {
    const savedCart = getSavedCart({}, 'lotpop-cart');
    if (savedCart) {
      this.props.addAposta(savedCart);
    } else {
      this.props.addAposta([]);
    }

    if (this.props.eTickets.length <= 0) {
      this.setState({ messageETicket: "Não há jogos realizados" });
    }

    this.verificaFluxoRepeticao();
    window.addEventListener("orientationchange", this.doOnOrientationChange);

    this.setState({ hasPreTicketParam: hasPreTicketParam() });
    this.setState({ hasPixParam: hasPixParam() });
    this.setState({ hasWalletParam: hasWalletParam() });
    this.setState({ hasLogin: hasLogin() });
  }

  componentWillUnmount() {
    window.removeEventListener("orientationchange", this.doOnOrientationChange);
  }

  doOnOrientationChange() {
    var mql = window.matchMedia("(orientation: landscape)");

    if (mql.matches) {
      this.setState({ orientation: "portrait" });
    } else {
      this.setState({ orientation: "landscape" });
    }
  }

  overlay() {
    if (this.props.isFetching) {
      return (
        <div className="overlay">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    return <div></div>;
  }

  verificaFluxoRepeticao() {
    let id = 0;
    let valorTotal = 0;
    let list = this.props.list || [];

    if (this.props.arrRepeticao && this.props.arrRepeticao.length > 0) {
      const arrRepeticao = this.props.arrRepeticao;
      var arrApostas = [];
      var auxValor = 0;

      for (var i = 0; i < arrRepeticao.length; i++) {
        auxValor = arrRepeticao[i].numValor * 100;
        let tipoJogo = list.filter(
          (tj) => tj.objTipoJogo.sntTipoJogo == arrRepeticao[i].sntTipoJogo
        )[0].objTipoJogo;

        if (tipoJogo) {
          arrApostas.push({
            Aposta_ID: ++id,
            tipo: tipoJogo,
            valor: auxValor,
            valorTotal: auxValor * arrRepeticao[i].arrNumero.length,
            numeros: arrRepeticao[i].arrNumero.sort(),
            strPremiosVisualizacao: this.getVizualizacaoSelectedPremio(
              arrRepeticao[i].arrPremio
            ),
            strPremioEnvio: this.getEnvioSelectedPremio(
              arrRepeticao[i].arrPremio
            ),
            resetParams: [
              this.props.modalidade,
              arrRepeticao[i].arrNumero
            ]
          });

          valorTotal += auxValor * arrRepeticao[i].arrNumero.length;
        }
      }

      //Adicionar a aposta ao carrinho
      this.props.addAposta(arrApostas);
      saveCart({}, arrApostas, 'lotpop-cart');

      this.props.repeatedAposta({
        arrAposta: [],
      });

      const numExtracoes = (this.state.listExtracoesSelecionadas || []).length;

      this.setState({
        Aposta_ID: id,
        totalGeral: valorTotal * numExtracoes,
      });
    }
  }

  apostaButtonClick() {
    this.props.AnalyticsSetGameStep('Add to Cart');
    saveCart({}, this.props.arrApostas, 'lotpop-cart');
    this.adicionaAposta();
  }

  surpresaButtonClick() {
    const tipoJogo = this.props.modalidade.objTipoJogo;
    const qtdLoop = 7;
    const timeInterval = 100;
    var multiplier = 1;

    for (var i = 0; i <= qtdLoop; i++) {
      switch (qtdLoop - i) {
        case 0:
          multiplier = 5 * timeInterval;
          break;
        case 1:
          multiplier = 3 * timeInterval;
          break;
        case 2:
          multiplier = 1 * timeInterval;
          break;
      }

      setTimeout(
        function () {
          var surpresa = geraSurpresinha(tipoJogo);
          this.props.changeNumerpAposta(surpresa);
        }.bind(this),
        i * timeInterval + multiplier
      );
    }
  }

  renderJogoBody(sntTipoJogo) {
    if (this.state.tipoJogoCorrente != sntTipoJogo) {
      this.setState({
        tipoJogoCorrente: sntTipoJogo,
      });
      this.props.changeNumeroApostaClearAll();
    }

    const numPalpitesTotal = (this.props.arrApostas || []).reduce(
      (sum, ap) => (ap.numeros || []).length + sum,
      0
    );

    return (
      <ModalidadeInput
        modalidade={this.props.modalidade}
        handleInputChange={this.handleInputChange}
        handleAdicionarClick={this.apostaButtonClick}
        handleSurpresaClick={this.surpresaButtonClick}
        handleLimparClick={this.limparSelecao}
        orientation={this.state.orientation}
        toggleErrorModal={this.props.toggleErrorModal}
        maxAmount={100 - numPalpitesTotal}
      />
    );
  }

  renderPremios() {
    var arrPremios = [];

    //Possui prêmios fixos
    const qtdPremiosFixo = this.props.modalidade.lstPremioFixo
      ? this.props.modalidade.lstPremioFixo.length
      : 0;

    if (qtdPremiosFixo > 0) {
      arrPremios = new Array(qtdPremiosFixo);

      const lstPremioFixo = this.props.modalidade.lstPremioFixo;
      for (var i = 0; i < lstPremioFixo.length; i++) {
        arrPremios[i] = lstPremioFixo[i].vchPremioFixo;
      }
    } //Não possui prêmios fixos
    else {
      const lstPremioExtracao = this.props.modalidade.lstPremioExtracao;
      const premioExtracao = extractDefaultPremioExtracao(lstPremioExtracao);

      if (premioExtracao) {
        const tnyPremioMenor = premioExtracao.tnyPremioMenor;
        const tnyPremioMaior = premioExtracao.tnyPremioMaior;
        var arrSize = tnyPremioMaior - tnyPremioMenor + 1;
        arrSize = arrSize + 1; //Mais um para o botão de todos
        arrPremios = new Array(arrSize);

        for (var i = tnyPremioMenor; i <= tnyPremioMaior; i++) {
          arrPremios[i] = i;
        }

        arrPremios[arrSize] = 0; //Registro de 'TODOS'
      }
    }

    const unicoPremio = arrPremios.length === 1;

    return arrPremios.map((premio) => {
      var isPremioFixo = false;
      try {
        isPremioFixo = premio.split(".").length > 1 || arrPremios.length < 2;
      } catch (ex) { }

      let premioDescricao;
      let labelStyle;
      if (!isPremioFixo) {
        premioDescricao = premio > 0 ? premio : "Todos";
        labelStyle = { width: premio > 0 ? "" : "15%" };
      } else {
        premioDescricao = premio.split(".").join(" ao ");
        labelStyle = { width: "15%" };
      }
      let itemStyle = {};
      if (premioDescricao.length > 4) {
        labelStyle.width = "auto";
        itemStyle.display = "inline";
      }

      if (unicoPremio) {
        const evt = document.getElementById(`checkbox${premio}`) || undefined;
        if (evt != undefined && this.state.listPremiosSelecionados.length < 1) {
          evt.click();
        }
      }

      return (
        <li className={`${this.props.isNewDesign ? "isNewDesign" : ""}`}>
          <input
            type="checkbox"
            className="checkPremio"
            id={`checkbox${premio}`}
            value={premio}
            onClick={(evt) => {
              this.handlePremioClick(premio, evt.target, unicoPremio);
            }}
          />
          <label
            className="default-button"
            htmlFor={`checkbox${premio}`}
            style={labelStyle}
          >
            {premioDescricao}
            {premioDescricao !== "Todos" ? "º" : ""}
          </label>
        </li>
      );
    });
  }

  handleChkExtracaoChange(extracao) {
    this.props.AnalyticsSetGameStep('Select Extraction');
    this.setState({ listExtracoesSelecionadas: extracao });
    const totalGeral = this.newValorTotal(
      this.props.arrApostas,
      extracao.length
    );

    if (totalGeral !== undefined) {
      this.setState({
        totalGeral: totalGeral,
      });
    }
  }

  handlePremioClick(premio, target, unico) {
    this.props.AnalyticsSetGameStep('Select Award');
    var checked = target.checked;
    var list = this.state.listPremiosSelecionados;
    var lstChk = document.getElementsByClassName("checkPremio");
    var isPremioFixo = false;

    try {
      isPremioFixo = premio.split(".").length > 1 || unico;
    } catch (ex) { }

    //Se for prêmio variável
    if (!isPremioFixo) {
      //Garante o formato inteiro
      premio = parseInt(premio);
      if (premio == 0) {
        //Clique da opção de TODOS

        const check = lstChk[lstChk.length - 1].checked;

        list = [];
        for (var i = 0; i <= lstChk.length - 2; i++) {
          // o -2 é para ignorar o registro de TODOS
          lstChk[i].checked = check;
          if (check) {
            list.push(parseInt(lstChk[i].value));
          }
        }

        this.setState({ listPremiosSelecionados: list });
      } //Clique nos prêmios
      else {
        if (checked) {
          list.push(premio);
        } else {
          list = arrayRemove(list, premio);
        }

        this.setState({ listPremiosSelecionados: list });

        //Marca ou desmarca a opção de todos automáticamente
        if (list.length == lstChk.length - 1) {
          //o -1 é para ignorar o registro de TODOS
          lstChk[lstChk.length - 1].checked = true;
        } else {
          lstChk[lstChk.length - 1].checked = false;
        }
      }
    } // Se for prêmio fixo
    else {
      if (unico) {
        list = [];
        const lstPremiosFixo = premio.split(".");
        if (lstPremiosFixo.length > 0) {
          if (lstPremiosFixo.length > 1) {
            const prMinimo = parseInt(lstPremiosFixo[0]);
            const prMaximo = parseInt(lstPremiosFixo[1]);

            for (var i = prMinimo; i <= prMaximo; i++) {
              list.push(i);
            }
          } else {
            list.push(parseInt(lstPremiosFixo[0]));
          }

          this.setState({ listPremiosSelecionados: list });
          target.checked = checked;
        }
      } else if (checked) {
        list = [];
        const lstPremiosFixo = premio.split(".");
        if (lstPremiosFixo.length > 0) {
          if (lstPremiosFixo.length > 1) {
            const prMinimo = parseInt(lstPremiosFixo[0]);
            const prMaximo = parseInt(lstPremiosFixo[1]);

            for (var i = prMinimo; i <= prMaximo; i++) {
              list.push(i);
            }
          } else {
            list.push(parseInt(lstPremiosFixo[0]));
          }

          this.setState({ listPremiosSelecionados: list });
        }

        //Desmarca todos os prêmios
        for (var i = 0; i < lstChk.length; i++) {
          lstChk[i].checked = false;
        }
        //Marca apenas o selecionado
        target.checked = checked;
      } else {
        this.setState({ listPremiosSelecionados: [] });
      }
    }
    if (unico) {
      //Se for unico é sempre true, nao desmarca.
      target.checked = true;
    }
  }

  getVizualizacaoSelectedPremio(list) {
    list = list.sort((a, b) => a - b);
    if (list.length == 1) return list[0].toString();
    if (list.length > 0) {
      const fst = list[0];
      const last = list[list.length - 1];

      if (last - fst == list.length - 1) {
        return `${fst} ao ${last}`;
      } else {
        var retorno = "";
        for (var i = 0; i <= list.length - 1; i++) {
          retorno += `${list[i]} - `;
        }
        return retorno.substring(0, retorno.length - 3); //3 caracteres por conta dos espaços
      }
    }
    return "";
  }

  getEnvioSelectedPremio(list) {
    list = list.sort((a, b) => a - b);
    if (list.length > 0) {
      const fst = list[0];
      const last = list[list.length - 1];
      if (fst === last) {
        return `${fst}`;
      } else {
        var retorno = "";
        if (last === list.length) {
          retorno = `${fst}.${last}`;
        } else {
          retorno = list.join("");
        }
        return retorno;
      }
    }
    return "";
  }

  checkCarrinhoButton() {
    return (
      this.props.arrNumerosAposta.length > 0 &&
      this.state.valorTotal > 0 &&
      this.state.listPremiosSelecionados.length > 0
    );
  }

  adicionaAposta() {
    var arrNumeros = this.props.arrNumerosAposta;

    const tnyQtdMinimaPremio =
      this.props.modalidade.objTipoJogo.tnyQtdMinimaPremio;
    const tnyQtdMaximaPremio =
      this.props.modalidade.objTipoJogo.tnyQtdMaximaPremio;

    const hasFixedPrizes =
      this.props.modalidade &&
      this.props.modalidade.lstPremioFixo &&
      !!this.props.modalidade.lstPremioFixo.length;
    const applyToFixedPrizes =
      this.props.modalidade &&
      this.props.modalidade.objTipoJogo &&
      !!this.props.modalidade.objTipoJogo.bitMultQtdPremios;

    const forEach =
      (!hasFixedPrizes || applyToFixedPrizes) &&
      !!(
        this.props.objUser &&
        this.props.objUser.config &&
        this.props.objUser.config.tnyModoInputWeb == 1
      );
    const forAll = !!(
      this.props.objUser &&
      this.props.objUser.config &&
      this.props.objUser.config.tnyModoInputWeb == 2
    );

    const multiplier =
      (forAll ? 1 / arrNumeros.length : 1) *
      (forEach ? this.state.listPremiosSelecionados.length : 1);

    if (arrNumeros.length == 0) {
      this.props.toggleErrorModal(
        "Aposta Inválida",
        "Informe ao menos um palpite."
      );
    } else if (this.state.valorTotal == 0) {
      this.props.toggleErrorModal("Aposta Inválida", "Valor inválido.");
    } else if (this.state.listPremiosSelecionados.length == 0) {
      this.props.toggleErrorModal(
        "Aposta Inválida",
        "Selecione pelo menos um prêmio."
      );
    } else if (
      (tnyQtdMinimaPremio > 0 &&
        this.state.listPremiosSelecionados.length < tnyQtdMinimaPremio) ||
      (tnyQtdMaximaPremio > 0 &&
        this.state.listPremiosSelecionados.length > tnyQtdMaximaPremio)
    ) {
      this.props.toggleErrorModal(
        "Aposta Inválida",
        `Selecione de ${tnyQtdMinimaPremio} à ${tnyQtdMaximaPremio} prêmios.`
      );
    } else {
      var totalGeral = 0;

      //Validar a aposta corrente.
      //const numeroAposta = limpaApostaNumeroSeparador(numeroAp, this.props.modalidade.objTipoJogo);

      var arrApostas = this.props.arrApostas;
      var Aposta_ID = this.state.Aposta_ID + 1;

      const modalidade = this.props.modalidade;
      const valor = this.state.valorTotal * multiplier;

      arrApostas.push({
        Aposta_ID: Aposta_ID,
        tipo: this.props.modalidade.objTipoJogo,
        valor: valor,
        valorTotal: valor * arrNumeros.length,
        numeros: arrNumeros,
        strPremiosVisualizacao: this.getVizualizacaoSelectedPremio(
          this.state.listPremiosSelecionados
        ),
        strPremioEnvio: this.getEnvioSelectedPremio(
          this.state.listPremiosSelecionados
        ),
        resetParams: [
          modalidade,
          arrNumeros
        ]
      });

      //Adicionar a aposta ao carrinho
      this.props.addAposta(arrApostas);
      saveCart({}, arrApostas, 'lotpop-cart');

      totalGeral += this.state.valorTotal * multiplier;

      this.setState({
        Aposta_ID: Aposta_ID,
      });

      this.setState({
        totalGeral: this.newValorTotal(
          arrApostas,
          (this.state.listExtracoesSelecionadas || []).length
        ),
      });

      this.props.changeNumeroApostaClearAll();

      if (this.state.orientation === "portrait") {
        toastr.success("", "Aposta(s) adicionada(s) com sucesso!");
      }
      this.carrinhoRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  reusaAposta(modalidade, arrNumeros) {
    this.props.selectModalidade(modalidade);
    setTimeout(() => {
      this.props.addNumeroAposta(arrNumeros);
      const scrollToBetManager = window["scrollToBetManager"];
      if (typeof scrollToBetManager === "function") {
        scrollToBetManager();
      }
    }, 0);
  };

  apagaAposta(Aposta_ID, valorAposta) {
    this.props.removeAposta(Aposta_ID);
    var novoValor =
      this.state.totalGeral -
      valorAposta *
      (this.state.listExtracoesSelecionadas.length == 0
        ? 1
        : this.state.listExtracoesSelecionadas.length);
    this.setState({ totalGeral: novoValor });
    saveCart({}, this.props.arrApostas, 'lotpop-cart');
  }

  newValorTotal(arrApostas, qtdExtracoes) {
    if (arrApostas != undefined && arrApostas.length > 0) {
      return (
        arrApostas.reduce((sum, aposta) => {
          return sum + aposta.valorTotal;
        }, 0) * qtdExtracoes
      );
    } else {
      return undefined;
    }
  }

  limparSelecao() {
    if (this.props.eTickets.length <= 0) {
      this.setState({ messageETicket: "Não há jogos realizados" });
    }

    this.setState({
      Aposta_ID: 0,
      possivelRetorno: "0,00",
      valorTotal: 0,
      totalGeral: 0,
      messageETicket:
        this.props.eTickets.length <= 0 ? "Não há jogos realizados" : "",
      showETicket: false,
      listPremiosSelecionados: [],
      listExtracoesSelecionadas: [],
    });

    this.props.changeNumerpApostaClear();
    this.props.setExtracoesSelecionadas([]);

    if (this.chkExtracoes) this.chkExtracoes.reset();

    var isChecked = document.querySelector(
      `input[name="${this.state.radioGroupName}"]:checked`
    );

    if (!!isChecked) {
      isChecked.checked = false;
    }
    var lstChk = document.getElementsByClassName("checkPremio");
    for (var i = 0; i <= lstChk.length - 1; i++) {
      lstChk[i].checked = false;
    }

    lstChk = document.getElementsByClassName(this.state.radioGroupName);
    for (var i = 0; i <= lstChk.length - 1; i++) {
      lstChk[i].checked = false;
    }
  }

  atualizaPossivelRetorno(rawValue, displayValue) {
    this.setState({
      possivelRetorno: convertIntegerToMoney(rawValue),
      valorTotal: rawValue,
    });
  }

  createTransaction(isPreTicket = false, isPix = false) {
    this.props.AnalyticsSetGameStep('Start Payment');
    var arrExtracaoData = [];
    var arrAposta = [];
    var transaction = {};

    var moment = require("moment");
    var now = moment();

    this.setState({ isPreTicket });

    if (this.props.arrApostas.length <= 0) {
      this.props.toggleErrorModal(
        "Carrinho vazio!",
        "Favor adicionar um item ao carrihno."
      );
    } else if (this.state.listExtracoesSelecionadas < 1) {
      this.props.toggleErrorModal(
        "Aposta Inválida",
        "Favor selecionar ao menos uma extração."
      );
      return;
    } else {
      var dataDaAposta = this.state.apostaDate
        ? Moment(this.state.apostaDate).format("YYYY-MM-DD")
        : Moment().format("YYYY-MM-DD");
      for (var i = 0; i < this.state.listExtracoesSelecionadas.length; i++) {
        var tnyExtracao = this.state.listExtracoesSelecionadas[i];
        var data = {
          sdtData: dataDaAposta, //Moment().format("YYYY-MM-DD"),
          tnyExtracao: tnyExtracao,
          vchDescricao: getExtracaoDescricao(this.props.extracoes, tnyExtracao),
        };

        arrExtracaoData.push(data);
      }

      var numValorTotal = 0;
      for (var i = 0; i < this.props.arrApostas.length; i++) {
        var apostaCorrente = this.props.arrApostas[i];
        var arrNum = apostaCorrente.numeros;

        for (var j = 0; j < arrNum.length; j++) {
          var numCorrente = arrNum[j];

          var aposta = {
            sntTipoJogo: apostaCorrente.tipo.sntTipoJogo,
            vchNumero: numCorrente,
            vchPremio: apostaCorrente.strPremioEnvio,
            numValor: apostaCorrente.valor / 100,
            numValorTotal: apostaCorrente.valor / 100,
          };

          numValorTotal += apostaCorrente.valor;
          arrAposta.push(aposta);
        }
      }

      transaction.Cliente_ID = this.props.objUser.Cliente_ID;
      transaction.Site_ID = forceInt(this.props.objUser.Site_ID);
      transaction.CID = this.props.objUser.CID;
      transaction.chrSerial = this.props.objUser.ChrSerial;
      transaction.chrCodigoPonto = this.props.objUser.ChrCodigoPonto;
      transaction.chrCodigoOperador = this.props.objUser.ChrCodigoOperador;
      transaction.Session_ID = this.props.objUser.Session_ID;
      transaction.strToken = this.props.objUser.TokenLE;
      transaction.sdtDataHora = new Date();
      transaction.arrExtracaoData = arrExtracaoData;
      transaction.arrApostas = arrAposta;
      transaction.Carrinho = this.props.arrApostas;
      transaction.numValorApostas = numValorTotal / 100;
      transaction.sntQuantidadeApostas = arrAposta.length;
      transaction.valorTotal = numValorTotal / 100;
      transaction.bitPredatado =
        now.format("DD/MM/YYYY") !=
        Moment(this.state.apostaDate).format("DD/MM/YYYY");

      this.props.enviarAposta(
        transaction,
        this.eTicketOK,
        isPreTicket,
        isPix,
        (title, message) => {
          this.props.toggleErrorModal(title, message);
        }
      );
    }
  }

  eTicketOK(eTicket, isPreTicket, isPix) {
    if (eTicket) {
      this.props.AnalyticsSetFinishPurchase(eTicket.detail.numValorApostas);
      this.limparSelecao();
      this.props.addAposta([]);
      removeSavedCart('lotpop-cart');

      this.setState({
        messageETicket:
          this.props.eTickets.length <= 0 ? "Não há jogos realizados" : "",
        currentETicket: isPix ? null : eTicket,
        currentPixTicket: isPix ? eTicket : null,
        showETicket: true,
        isPreTicket: isPix ? false : isPreTicket,
      });
    }
  }

  toggleETicketModal() {
    this.setState({
      showETicket: !this.state.showETicket,
    });
  }

  renderTicket(ETicket, isPreTicket = false) {
    /**
     * Visto que a estrutura dos dados Para a a geração do card de bilhete não são Uniformes
     * a longo da aplicação, se torna necessário mapear para uma estrutura aceita pelo componente
     */
    const oUser = this.props.objUser;

    if (oUser.TokenLE == "") {
      oUser.TokenLE = ETicket.TokenLE;
      oUser.LoginLE = ETicket.LoginLE;

      this.props.startSession(oUser);
    }
    const arrJogo = ETicket.detail.Carrinho.map((ap) => {
      return {
        //arrNumeros: formataNumeroApostaSeparador(ap.numeros, ap.tipo),
        arrNumeros: ap.numeros,
        valor: ap.valor,
        valorTotal: ap.valorTotal,
        nome: ap.tipo.vchNome,
        possivelRetorno: ap.valor,
        premio: ap.strPremiosVisualizacao,
      };
    });

    const arrBilhetes = ETicket.detail.arrExtracaoData.map((ap, i) => {
      return {
        bets: undefined,
        value: ETicket.detail.numValorApostas,
        date: ETicket.detail.sdtDataHora.toLocaleString(),
        prize: arrJogo.reduce((sum, item) => sum + item.valorTotal, 0),
        extraction: `${ap.vchDescricao} - ${Moment(
          this.state.apostaDate
        ).format("DD/MM/YYYY")}`,
        concurso: undefined,
        venda: isPreTicket ? null : ETicket.arrETicket[i],
        name: ETicket.detail.Carrinho[0].tipo.vchNome,
        image: undefined,
        arrJogo: arrJogo,
        isLoteria: !ETicket.detail.bitConcurso,
        intNumeroPule: isPreTicket ? null : ETicket.arrIntNumeroPule[i],
        vchCodigoSeguranca: isPreTicket ? null : ETicket.arrCodigoSeguranca[i],
        chrSerial: this.props.objUser.ChrSerial,
        maxDate: `${Moment(this.state.apostaDate).format("DD/MM/YYYY")}`,
      };
    });

    if (isPreTicket)
      savePreTicket({
        bilhetes: arrBilhetes,
        preTicket: ETicket.vchPreTicket,
        tipoJogoCategoria: "Loteria Pop",
      });
    return (
      <Ticket
        bilhetes={arrBilhetes}
        onClose={this.toggleETicketModal}
        preTicket={ETicket.vchPreTicket}
        toggleErrorModal={(...params) => {
          this.props.toggleErrorModal(...params);
        }}
      />
    );
  }

  renderPixTicket(ETicket) {
    const arrJogo = ETicket.detail.Carrinho.map((ap) => {
      return {
        arrNumeros: ap.numeros,
        valor: ap.valor,
        valorTotal: ap.valorTotal,
        nome: ap.tipo.vchNome,
        possivelRetorno: ap.valor,
        premio: ap.strPremiosVisualizacao,
      };
    });

    const arrBilhetes = ETicket.detail.arrExtracaoData.map((ap, i) => {
      return {
        value: ETicket.detail.numValorApostas,
        date: ETicket.detail.sdtDataHora.toLocaleString(),
        prize: arrJogo.reduce((sum, item) => sum + item.valorTotal, 0),
        extraction: `${ap.vchDescricao} - ${Moment(
          this.state.apostaDate
        ).format("DD/MM/YYYY")}`,
        name: ETicket.detail.Carrinho[0].tipo.vchNome,
        arrJogo: arrJogo,
        isLoteria: !ETicket.detail.bitConcurso,
      };
    });

    const objTipoJogo = this.state.activeModalidade.objTipoJogo;

    const ticket = {
      bilhetes: arrBilhetes,
      timestamp: Date.now(),
      objTipoJogo: objTipoJogo,
      ...ETicket,
    };

    return (
      <PixTicket
        ticket={ticket}
        onClose={this.toggleETicketModal}
        toggleErrorModal={(...params) => {
          this.props.toggleErrorModal(...params);
        }}
      />
    );
  }

  doOnOrientationChange() {
    var mql = window.matchMedia("(orientation: landscape)");

    if (mql.matches) {
      this.setState({ orientation: "portrait" });
    } else {
      this.setState({ orientation: "landscape" });
    }
  }

  goHome() {
    this.props.selectConcursoScreen(0);
  }

  incrementValue(rawValue) {
    let newValue = this.state.valorTotal + rawValue;

    if (newValue < 0) {
      newValue = 0;
    }

    this.setState({
      possivelRetorno: convertIntegerToMoney(newValue),
      valorTotal: newValue,
    });
  }

  dateSelect(apostaData) {
    this.setState({ apostaDate: apostaData });
    this.handleChkExtracaoChange([]);
  }

  getMaxPrize(currentBetInCents = 0) {
    const currentBet = currentBetInCents / 100;
    const multiplier = this.getMultiplier();

    const maxPrize = multiplier * currentBet;

    return maxPrize;
  }

  getMultiplier() {
    try {
      return this.state.activeModalidade.objTipoJogo.numValorPagoJogo;
    } catch (e) {
      return 0;
    }
  }

  renderLoteriaBody() {
    const tipoJogo = this.props.modalidade.objTipoJogo;
    var isLandscape = this.props.orientation === "landscape";
    // var pullRight = isLandscape ? "" : "pull-right";

    return (
      <div className="concurso-input-container">
        <div style={{ marginTop: "5px" }}>
          <div
            className="box box-solid"
            style={{ marginBottom: "5px" }}
            ref={this.apostaRef}
          >
            <div className="box-header with-border">
              <div className="row text-center">
                {this.renderJogoBody(tipoJogo.sntTipoJogo)}
              </div>
            </div>
            <div className="box-header with-border col-12 col-md-6 modalidade-input-container-title">
              <label
                style={{
                  fontSize: "15px",
                }}
              >
                2. Prêmios
              </label>
              <div className="row text-center">
                <ul className="ks-cboxtags" style={{ paddingTop: "0px" }}>
                  {this.renderPremios()}
                </ul>
              </div>
            </div>

            <div className="box-header with-border col-12 col-md-6 modalidade-input-container-title">
              <ValorInput
                title="3. Valor"
                value={this.state.valorTotal}
                onChange={(newValue) => {
                  this.props.AnalyticsSetGameStep('Select Value');
                  this.setState({
                    possivelRetorno: convertIntegerToMoney(newValue),
                    valorTotal: newValue,
                  });
                }}
                minValue={tipoJogo.numValorMinimoAposta}
              />
            </div>

            <div className="box-footer">
              <div className="row w-full">
                <div
                  className={
                    "col-md-12 col-sm-12 col-xs-12" +
                    (isLandscape ? " nopadding" : "")
                  }
                >
                  <div className="col-md-12 col-sm-12 col-xs-12 pull-right add-to-cart-container">
                    {true && (
                      <button
                        type="button"
                        className="btn btn-success submit-button pull-right add-to-cart-button sm-w-full"
                        onClick={this.apostaButtonClick}
                      >
                        Adicionar ao Carrinho
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="box box-solid with-border">
            <Carrinho
              apostas={this.props.arrApostas}
              apagaAposta={(Aposta_ID, valorAposta) =>
                this.apagaAposta(Aposta_ID, valorAposta)
              }
              reusaAposta={this.reusaAposta}
            />
            <div
              className="box-footer with-border"
              style={{ paddingTop: "0px" }}
              ref={this.carrinhoRef}
            >
              <div>
                <ExtracaoSelector
                  handleChange={this.handleChkExtracaoChange}
                  groupName={this.state.radioGroupName}
                  dateSelect={this.dateSelect}
                />
              </div>

              <PayButton
                gameType="loteria"
                hasLogin={this.state.hasLogin}
                hasPix={this.state.hasPixParam}
                hasPreTicket={this.state.hasPreTicketParam}
                hasWallet={this.state.hasWalletParam}
                totalValue={this.state.totalGeral}
                createTransaction={this.createTransaction}
                selections={this.state.listExtracoesSelecionadas}
              />

              {/* <div className="buttons-container-row">
                {this.state.hasWalletParam && (
                  <button
                    type="button"
                    className={`btn btn-primary submit-button  pull-right`}
                    onClick={() => this.createTransaction(false, false)}
                  >
                    + Finalizar
                    {this.state.totalGeral > 0 &&
                      ` - R$ ${convertIntegerToMoney(this.state.totalGeral)}`}
                  </button>
                )}
                {this.state.totalGeral > 0 &&
                  this.state.hasPixParam &&
                  this.state.hasLogin &&
                  (this.state.listExtracoesSelecionadas || []).length > 0 && (
                    <button
                      type="button"
                      className={`btn btn-primary pull-right submit-button sm-w-full`}
                      onClick={() => this.createTransaction(false, true)}
                    >
                      Pagar Agora!
                      {this.state.totalGeral > 0 &&
                        ` - R$ ${convertIntegerToMoney(this.state.totalGeral)}`}
                    </button>
                  )}
                {this.state.hasPreTicketParam && (
                  <button
                    type="button"
                    className={`btn btn-primary pull-right submit-button`}
                    onClick={() => this.createTransaction(true, false)}
                  >
                    Gerar pre-ticket
                  </button>
                )}
              </div> */}
            </div>
            {this.overlay()}
          </div>
        </div>
        {this.state.currentETicket &&
          this.state.showETicket &&
          this.renderTicket(this.state.currentETicket, this.state.isPreTicket)}
        {this.state.currentPixTicket &&
          this.state.showETicket &&
          this.renderPixTicket(this.state.currentPixTicket)}
      </div>
    );
  }

  render() {
    const showBody = this.props.modalidade ? true : false;

    if (this.state.activeModalidade != this.props.modalidade) {
      this.clearBody();
      this.setState({ activeModalidade: this.props.modalidade });
    }

    return <div>{showBody ? this.renderLoteriaBody() : ""}</div>;
  }

  clearBody() {
    this.props.changeNumerpApostaClear();

    var lstChk = document.getElementsByClassName("checkPremio");
    for (var i = 0; i <= lstChk.length - 1; i++) {
      lstChk[i].checked = false;
    }

    this.setState({
      possivelRetorno: "0,00",
      valorTotal: 0,
      listPremiosSelecionados: [],
    });
  }
}

const mapStateToProps = (state) => ({
  modalidade: state.loteria.modalidade,
  list: state.loteria.objTipoJogo.listModalidade,
  extracoes: state.usuario.objUser.arrExtracoes,
  numeroAposta: state.modalidadeInput.numeroAposta,
  arrNumerosAposta: state.modalidadeInput.arrNumerosAposta,
  arrApostas: state.carrinho.arrApostas,
  objUser: state.usuario.objUser,
  isFetching: state.carrinho.isFetching,
  eTickets: state.carrinho.eTickets,
  ticketError: state.carrinho.ticketError,
  apostaDate: state.apostaDate,
  arrRepeticao: state.repeticao.arrAposta,
  isNewDesign: state.settings.isNewDesign,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectModalidade,
      addAposta,
      removeAposta,
      enviarAposta,
      changeNumerpApostaClear,
      changeNumerpAposta,
      addNumeroAposta,
      changeNumeroApostaClearAll,
      selectConcursoScreen,
      startSession,
      setExtracoesSelecionadas,
      repeatedAposta,
      AnalyticsSetGameStep,
      AnalyticsSetFinishPurchase,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoteriaBody);



// WEBPACK FOOTER //
// ./src/loteria/loteriaBody.jsx